import * as React from 'react';
import { Col, Row } from 'reactstrap';
import SidebarContainer from 'src/modules/Routing/Sidebar/SidebarContainer';
import EmailsConfigurationTable from './components/EmailsConfigurationTable';
import ConfirmationModal from 'src/share/components/ConfirmationModal/ConfirmationModal';
import EmailConfiguration from './components/EmailConfiguration';
import { useEmailsConfiguration } from './hooks/useEmailsConfiguration';
import { IServiceStatusRequest, IServiceStatusResponse } from 'src/share/types/serviceStatus';
import { RoutesModules } from 'src/modules/Routing/types';
import { IEmailConfiguration } from 'src/share/types/emailsConfiguration';
import { useEmailsLogs } from './hooks/useEmailsLogs';
import EmailsLogsTable from './components/EmailsLogsTable';
import './emailsConfiguration.css';

export enum IEmailTypes {
  TRANSFERCASE = "TRANSFERCASE",
  WELCOME = "WELCOME"
}

export interface IEmailsConfigurationState {
  search: IServiceStatusRequest;
  emailsConfiguration: IEmailConfiguration[];
  emailsLogs: IServiceStatusResponse;
  emailSelected: IEmailConfiguration;
  loadingEmailsConfig: boolean;
  loadingEmailsLogs: boolean;
  showModal: boolean;
}

const EmailsConfiguration: React.SFC = () => {
  const [emails, configurationActions] = useEmailsConfiguration();
  const [emailsLogs, logsActions] = useEmailsLogs();
  return (
    <div className="emails-configuration">
      <Row>
        <Col className='col-12'>
          <div className="emails-configuration-container white-background">
            <h3 className="title">Emails configuration</h3>
            <EmailsConfigurationTable
              emailsConfiguration={emails.data}
              onHandleModal={configurationActions.handleModal}
              loading={emails.isLoading}
            />
          </div>
          <div className="emails-logs-container white-background">
            <h3 className="title">Emails logs</h3>
            <EmailsLogsTable
              emailsLogs={emailsLogs.data}
              loading={emailsLogs.isLoading}
              total={emailsLogs.total}
              onSizeChanged={(size, page): void => logsActions.setSearchLogs(prevSearch => ({ ...prevSearch, size, page: page - 1 }))}
              onPageChanged={(page): void => logsActions.setSearchLogs(prevSearch => ({ ...prevSearch, page: page - 1 }))}
              onSort={logsActions.handleSort}
            />
          </div>
          {emails.showModal &&
            <div className='email-confirmation-modal-container'>
              <ConfirmationModal
                isOpen={emails.showModal}
                toggle={() => configurationActions.handleModal(emails.emailSelected.emailId)}
                title={`Edit the ${emails.emailSelected.displayName} configuration`}
                description={
                  <EmailConfiguration
                    emailConfiguration={{ ...emails.emailSelected }}
                    onHandleSelected={configurationActions.handleSelected}
                  />
                }
                onContinue={() => configurationActions.handleEmailConfiguration()}
              />
            </div>}
        </Col>
      </Row>
    </div>
  );
}

export default SidebarContainer(RoutesModules.ADMIN)(EmailsConfiguration);



// WEBPACK FOOTER //
// ./src/modules/UserSettings/EmailsConfiguration/EmailsConfiguration.tsx